import { assetUrl as appAssetUrl } from '../app-path.js';
import { toggleFavorite } from './autocompletev2.js'; // Importa a função central!
import LocalStorageHelper from './local-storage-helper.js';
import FavoriteCityService from './favorite-city-service.js';

export function initializeForecastFavoriteButton() {
  const button = $('#forecastFavButton');
  if (!button.length) {
    return;
  }

  const icon = button.find('img');
  const city = JSON.parse(button[0].dataset.info);
  const cityData = LocalStorageHelper.mapCityData(city)

  const updateUI = (isFavorited) => {
    const iconName = isFavorited ? 'star-filled' : 'star-empty';
    const title = isFavorited ? 'Remover dos favoritos' : 'Favoritar cidade';
    icon.attr('src', appAssetUrl(`/dist/images/v2/svg/${iconName}.svg`));
    button.attr({ title, 'aria-label': title });
  };

  const isSameFavoriteCity = (firstCity = {}, secondCity = {}) => {
    const firstId = FavoriteCityService.getCityStorageId(firstCity);
    const secondId = FavoriteCityService.getCityStorageId(secondCity);
    return Boolean(firstId && secondId && String(firstId) === String(secondId));
  };

  updateUI(FavoriteCityService.isCityFavorited(cityData));
  FavoriteCityService.refreshServerFavorites().then(() => {
    updateUI(FavoriteCityService.isCityFavorited(cityData));
  });

  if (!window._forecastFavListenerAdded) {
    document.addEventListener('favoriteChanged', (e) => {
      if (isSameFavoriteCity(e.detail.city, cityData)) {
        updateUI(e.detail.isFavorited);
      }
    });
    document.addEventListener('favoriteSync', () => {
      updateUI(FavoriteCityService.isCityFavorited(cityData));
    });
    window._forecastFavListenerAdded = true;
  }

  button.off('click').on('click', async () => {
    await toggleFavorite(
      cityData,
      'Card_Forecast_Button_Star',
      'city',
      button[0],
    );
  });
}
